import React from 'react';
import './LoaderWithText.css';

interface LoaderWithTextProps {
  text?: string;
  animated?: boolean;
  size?: 'small' | 'medium' | 'large';
  color?: string;
  textColor?: string;
}

const LoaderWithText: React.FC<LoaderWithTextProps> = ({
  text = 'LOAD',
  animated = false,
  size = 'medium',
  color = '#44b388',
  textColor
}) => {
  const sizeMap = {
    small: { container: '40px', text: '4px' },
    medium: { container: '60px', text: '6px' },
    large: { container: '80px', text: '8px' }
  };

  const currentSize = sizeMap[size];

  return (
    <div 
      className="loader-container"
      style={{ 
        width: currentSize.container, 
        height: currentSize.container 
      }}
    >
      <div 
        className="loader"
        style={{ 
          width: currentSize.container,
          color: color
        }}
      ></div>
      <div 
        className={animated ? 'loader-text-animated' : 'loader-text'}
        style={{ 
          fontSize: currentSize.text,
          color: textColor || '#ffffff'
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default LoaderWithText; 